import { Injectable, inject } from '@angular/core';
import { PlatformService } from '@shared/services/platform-service.service';
import { AuctionView } from 'src/app/articles-manager/interfaces/auction.interface';

@Injectable({
  providedIn: 'root',
})
export class AuctionDownloadedService {
  private _memorabidAuctions: Array<AuctionView> = [];
  private _marketplaceAuctions: Array<AuctionView> = [];
  private _memorabidAuctionSliceEnd: number = 0;
  private _marketplaceAuctionSliceEnd: number = 0;
  private _scrollPosition: number = 0;
  private _auctionSource: string = 'home';

  private _auctionCount: number = 0;

  // Cache of fully loaded auction details (keyed by idAuction)
  private readonly _preloadedAuctions = new Map<number, AuctionView>();

  public page: number = 0;
  public pageSize: number = 60;

  private readonly platformService = inject(PlatformService);

  public get memorabidAuctions(): Array<AuctionView> {
    return this._memorabidAuctions;
  }

  public set memorabidAuctions(value: Array<AuctionView>) {
    this._memorabidAuctions = value;
  }

  public get auctionCount(): number {
    return this._auctionCount;
  }

  public set auctionCount(value: number) {
    this._auctionCount = value;
  }

  public get marketplaceAuctions(): Array<AuctionView> {
    return this._marketplaceAuctions;
  }

  public set marketplaceAuctions(value: Array<AuctionView>) {
    this._marketplaceAuctions = value;
  }

  public get memorabidAuctionSliceEnd(): number {
    return this._memorabidAuctionSliceEnd;
  }

  public set memorabidAuctionSliceEnd(value: number) {
    this._memorabidAuctionSliceEnd = value;
  }

  public get marketplaceAuctionSliceEnd(): number {
    return this._marketplaceAuctionSliceEnd;
  }

  public set marketplaceAuctionSliceEnd(value: number) {
    this._marketplaceAuctionSliceEnd = value;
  }

  public get scrollPosition(): number {
    return this._scrollPosition;
  }

  public set scrollPosition(value: number) {
    this._scrollPosition = value;
  }

  public get auctionSource(): string {
    return this._auctionSource;
  }

  public set auctionSource(value: string) {
    this._auctionSource = value;
  }

  /**
   * Store a fully loaded auction in the preload cache.
   * New data overwrites previous entry.
   */
  public cacheAuctionDetail(auction: AuctionView): void {
    if (auction?.idAuction != null) {
      this._preloadedAuctions.set(auction.idAuction, auction);
    }
  }

  /**
   * Retrieve a preloaded auction (if present) without altering it.
   */
  public getPreloadedAuction(idAuction: number): AuctionView | undefined {
    return this._preloadedAuctions.get(idAuction);
  }

  /**
   * Optionally clear one or all cached auctions to free memory.
   */
  public clearPreloadedAuction(idAuction?: number): void {
    if (idAuction != null) {
      this._preloadedAuctions.delete(idAuction);
    } else {
      this._preloadedAuctions.clear();
    }
  }

  restoreScrollPosition(
    forSource: string = null,
    behavior: 'auto' | 'smooth' = 'smooth'
  ) {

    this.platformService.runOnBrowser(() => {
      if (this._auctionSource === forSource || !forSource) {
        window.scrollTo({
          behavior,
          top: this.scrollPosition,
          left: 0,
        });
      }
    });
  }
}
